import React, { memo } from "react";
import colors from "app/colors";
import { isAudio, isImage, isPdf, isVideo } from "modules/utils/Functions";
import {
  QuotedMessageXlFileIcon,
  QuotedMessageZipFileIcon,
  QuotedMessageUnknownFileIcon,
  QuotedMessageImageFileIcon,
  QuotedMessagePptFileIcon,
  QuotedMessageDocFileIcon,
  QuotedMessagePdfFileIcon,
  QuotedMessageAudioFileIcon,
  QuotedMessageVideoFileIcon,
} from "modules/icons";

interface IProps {
  contentType: string;
  fill?: string;
  size?: [number, number];
}

const QuotedMessageFileTypeIcon = ({
  contentType,
  fill = colors.gray50,
  size = [86, 86],
}: IProps) => {
  const width = `${size[0]}px`;
  const height = `${size[1]}px`;

  if (isImage(contentType)) {
    return <QuotedMessageImageFileIcon w={width} h={height} fill={fill} />;
  }
  if (isVideo(contentType)) {
    return <QuotedMessageVideoFileIcon w={width} h={height} fill={fill} />;
  }
  if (isAudio(contentType)) {
    return <QuotedMessageAudioFileIcon w={width} h={height} fill={fill} />;
  }
  if (isPdf(contentType)) {
    return <QuotedMessagePdfFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/msword") ||
    contentType.includes(
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    )
  ) {
    return <QuotedMessageDocFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/vnd.ms-powerpoint") ||
    contentType.includes(
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    )
  ) {
    return <QuotedMessagePptFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/vnd.ms-excel") ||
    contentType.includes(
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    )
  ) {
    return <QuotedMessageXlFileIcon w={width} h={height} fill={fill} />;
  }
  if (
    contentType.includes("application/zip") ||
    contentType.includes("application/x-zip-compressed")
  ) {
    return <QuotedMessageZipFileIcon w={width} h={height} fill={fill} />;
  }
  return <QuotedMessageUnknownFileIcon w={width} h={height} fill={fill} />;
};

export default memo(QuotedMessageFileTypeIcon);
